import Person from '../models/person.model';

/**
 * Read a person retrieved from the backend with minimal data.
 * @param {Object} o
 * @return {Person}
 */
function readMinimalPerson(o) {
  return new Person(
    o.id,
    o.first_name,
    o.last_name,
    o.title,
    o.image,
    o.order_number,
    o.internet_active,
    o.gender,
    o.url,
  );
}

/**
 * Read a person retrieved from the backend with full data.
 * @param {Object} o
 * @return {Person}
 */
function readPerson(o) {
  const p = readMinimalPerson(o);

  p.locations = o.locations;
  p.spoken_languages = o.spoken_languages;
  p.description = o.description;
  p.service_categories = o.service_categories;
  p.service_groups = o.service_groups;
  p.specializations = o.specializations;
  p.services = o.services;
  p.other_services = o.other_services;
  p.job_title = o.job_title;
  p.serves_service_voucher_patients = o.serves_service_voucher_patients;
  p.service_voucher_locations = o.service_voucher_locations;

  return p;
}

export {
  readPerson,
  readMinimalPerson
};
